import React, { useEffect } from 'react';
import { Button, Form, message, Spin } from 'antd';
import { useGetInvoiceFooter } from '../../hooks/invoice/useGetInvoiceFooter';
import BreadCrumbs from '../../components/core/BreadCrumbs';
import TextEditor from '../../components/TextEditor';
import { useInvoiceFooterUpdate } from '../../hooks/invoice/useInvoiceFooterUpdate';
const BREAD_CRUMBS = [
  { label: 'Invoice', to: '/user/invoicelist' },
  { label: 'Invoice Footer Content', to: '/user/invoice-footer-content' },
];

export const InvoiceFooterContent = () => {
  const { loading, getData } = useGetInvoiceFooter();
  const [form] = Form.useForm();
  const { loading: updatingInvoiceFooter, updateInvoice } =
    useInvoiceFooterUpdate();

  const fetchInvoiceFooter = async () => {
    const invoiceFooter = await getData();
    form.setFieldsValue({
      content: invoiceFooter?.content,
    });
  };

  useEffect(() => {
    fetchInvoiceFooter();
  }, []);

  const handleSubmit = async (values) => {
    // Update invoice footer
    try {
      await updateInvoice(values);
      message.success('Invoice footer updated successfully');
    } catch (error) {
      console.log('Error on update invoice footer : ', error);
    }
  };

  return (
    <>
      <BreadCrumbs items={BREAD_CRUMBS} />
      <div className="row">
        <div className="col-sm-12">
          <div className="card card-table show-entire">
            <div className="card-body p-4">
              <Spin spinning={loading}>
                <Form
                  form={form}
                  onFinish={handleSubmit}
                  clearOnDestroy
                  layout="vertical"
                >
                  <Form.Item
                    label="Footer Content"
                    name={'content'}
                    rules={[{ required: true, message: 'Content is required' }]}
                  >
                    <TextEditor />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      loading={updatingInvoiceFooter}
                      type="primary"
                      htmlType="submit"
                    >
                      Update
                    </Button>
                  </Form.Item>
                </Form>
              </Spin>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
